import React from 'react';
import ChatSidebar from '../components/ChatSidebar';
import ChatWindow from '../components/ChatWindow';
import { CreateConversationModal } from '../modals/CreateConversationModal';
import { AssignEmployeesModal } from '../modals/AssignEmployeesModal';
import { useWhatsApp } from '../hooks/useWhatsApp';

const WhatsAppDashboard = () => {
  const {
    conversations,
    activeConversationId,
    setActiveConversationId,
    activeConversation,
    activeMessages,
    loading,
    user,
    
    isCreating,
    isCreateModalOpen,
    setIsCreateModalOpen,
    newContact,
    setNewContact,
    handleCreateConversation,

    isAssignModalOpen,
    setIsAssignModalOpen,
    employees,
    selectedAssignees,
    isAssigning,
    employeeSearchQuery,
    setEmployeeSearchQuery,
    openAssignModal,
    handleToggleAssignee,
    handleAssign,

    loadMessages,
    handleSendMessage
  } = useWhatsApp();

  return (
    <div className="flex h-[calc(100vh-100px)] bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100">
      <ChatSidebar 
        conversations={conversations} 
        activeConversationId={activeConversationId}
        onSelectConversation={loadMessages}
        onCreateNew={() => setIsCreateModalOpen(true)}
        loading={loading}
      />
      
      <div className={`flex-1 flex-col h-full bg-white relative ${activeConversationId ? 'flex' : 'hidden md:flex'}`}>
        {activeConversation ? (
          <ChatWindow 
            conversation={activeConversation}
            messages={activeMessages}
            onSendMessage={handleSendMessage}
            currentUser={user}
            onBack={() => setActiveConversationId(null)}
            onOpenAssign={openAssignModal}
          />
        ) : (
          <div className="flex-1 flex items-center justify-center bg-gray-50/50">
            <div className="text-center flex flex-col items-center">
              <div className="w-20 h-20 bg-purple-50 text-purple-600 rounded-full flex items-center justify-center mb-6 shadow-sm border border-purple-100">
                <svg className="w-10 h-10 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 tracking-tight">WhatsApp ERP</h3>
              <p className="text-gray-500 mt-2 font-medium max-w-sm">
                Select a conversation from the sidebar or start a new one to connect with your customers.
              </p>
            </div>
          </div>
        )}
      </div>

      <CreateConversationModal 
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        newContact={newContact}
        setNewContact={setNewContact}
        handleCreateConversation={handleCreateConversation}
        isCreating={isCreating}
      />

      <AssignEmployeesModal 
        isOpen={isAssignModalOpen}
        onClose={() => setIsAssignModalOpen(false)}
        handleAssign={handleAssign}
        employeeSearchQuery={employeeSearchQuery}
        setEmployeeSearchQuery={setEmployeeSearchQuery}
        employees={employees}
        selectedAssignees={selectedAssignees}
        handleToggleAssignee={handleToggleAssignee}
        isAssigning={isAssigning}
      />
    </div>
  );
};

export default WhatsAppDashboard;
